import { useEffect } from "react"

import { Alert, Flex, Layout, Space, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"

import LoginHeader from "../../Components/LoginHeader"
import LogOutText from "../../Components/LogOutText"
import PrivacyPolicy from "../../Components/PrivacyPolicy"
import Icon from "../../Icon"
import utils from "../../Utils/utils"
import { userActions } from "../User/redux/user.slice"
import { getPremiumFeatures } from "../User/redux/user.thunks"
import PremiumCard from "./components/Card"

const { Title, Text } = Typography

function PremiumFeaturesPage(props) {
  const {
    auth: { fetching, userInfo },
    nav: { theme },
    userFetching,
    premiumFeatures
  } = props

  const { t } = useTranslation()

  let businessId = userInfo?.["current_business_account_id"]

  useEffect(() => {
    if (businessId) props.getPremiumFeatures({})

    document.title = "Premium services - Chargeback"
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  const handleClick = (service) => {
    if (service.is_active) {
    } else {
      if (service.link) utils.goLink(service.link)
    }
  }

  return (
    <Layout>
      <Spin size="large" spinning={fetching || userFetching}>
        <div className="login-row">
          <LoginHeader />
          <div className="login-content">
            <div className="content-main sign-up">
              <Flex
                vertical
                align={"center"}
                style={{ margin: "0 0 auto", width: "100%", maxWidth: 1040, padding: "0 24px" }}
              >
                <Flex
                  gap={16}
                  justify="space-between"
                  align="center"
                  style={{ width: "100%" }}
                  wrap="wrap"
                >
                  <Space direction="vertical" size={0}>
                    <Title level={5} style={{ width: 320, textAlign: "left" }}>
                      {t("Premium services")}
                    </Title>
                    <Text type={"secondary"} style={{ width: 320 }}>
                      {t(
                        "Check the premium services available for your business account. You may subscribe for any service or to purchase a package plan."
                      )}
                    </Text>
                  </Space>
                </Flex>

                <Alert
                  className="primary"
                  icon={<Icon type="sparkles_soft" />}
                  showIcon
                  message={<Text strong>{t("Important notice")}</Text>}
                  description={
                    <Text>
                      {t(
                        "The premium services are available only for business accounts connected to Shopify account and are charged exclusively through Shopify. If you disconnect your Shopify account while using any premium service, the service subscription will not be renewed for the following month."
                      )}
                    </Text>
                  }
                  style={{ margin: "32px 0 24px", width: "100%" }}
                />

                <Flex
                  gap={16}
                  wrap="wrap"
                  justify="space-between"
                  align="stretch"
                  style={{ margin: "0 0 24px", width: "100%" }}
                >
                  {premiumFeatures?.map((service) => {
                    return (
                      <PremiumCard
                        key={service.id}
                        data={service}
                        style={{ width: 320 }}
                        onClick={handleClick}
                        theme={theme}
                      />
                    )
                  })}
                </Flex>
              </Flex>

              <PrivacyPolicy />
              <LogOutText />
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  )
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  nav: state.nav,

  businessAccount: state.user.businessAccount,
  userFetching: state.user.fetching,
  premiumFeatures: state.user.premiumFeatures
})

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  getPremiumFeatures: (data) => dispatch(getPremiumFeatures(data)),

  userSaveResultReset: () => dispatch(userActions.userSaveResultReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(PremiumFeaturesPage)
